import { SonnerState } from '../toast-state.svelte.js';
import { Context } from 'runed';
export const richColorsContext = new Context('richColorsContext');
export const sonnerContext = new Context('<Toaster/>');
